/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Text
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportNumericForm } from 'labstep-web/components/FilterPost/NewIndex/Numeric/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostNewIndexNumericProps } from './types';

export const FilterPostNewIndexNumeric: React.FC<
  FilterPostNewIndexNumericProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  multiplicator,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy="components/FilterPost/NewIndex/Numeric"
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportNumericForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        multiplicator={multiplicator}
      />
    )}
    {...rest}
  />
);
